import { render, staticRenderFns } from "./CommercialIIDialCampaign.vue?vue&type=template&id=24e39241&scoped=true"
import script from "./CommercialIIDialCampaign.vue?vue&type=script&lang=js"
export * from "./CommercialIIDialCampaign.vue?vue&type=script&lang=js"
import style0 from "./CommercialIIDialCampaign.vue?vue&type=style&index=0&id=24e39241&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e39241",
  null
  
)

export default component.exports